module.exports = __webpack_public_path__ + "img/web-p2-c4.949ac9fb.svg";